"use client";

import routes from "@/app.route";
import { CheckIcon } from "lucide-react";
import Link from "next/link";

export default function DroneServices() {
  return (
    <div className="py-6 md:py-12 bg-linear-to-r from-primary to-secondary">
      <div className="max-w-7xl mx-auto px-4">
        <div className="max-w-2xl mx-auto mb-6 md:mb-10">
          <h2 className="md:text-4xl text-3xl text-center font-bold text-white">
            Drone Services by EVERSE
          </h2>
        </div>
        <p className="text-base md:text-2xl mb-4 md:mb-8 text-center text-white">
          EVERSE delivers{" "}
          <strong className="text-black">advanced drone-based solutions</strong>{" "}
          for infrastructure, environment, and industrial projects across India.
          We help organisations make{" "}
          <strong className="text-black">
            faster, safer, and data-driven decisions
          </strong>{" "}
          using modern UAV technology and experienced field teams.
        </p>
        <div className="flex justify-center mb-6">
          <div className="bg-white/50 font-semibold inline-block px-3 py-1 rounded-lg text-base lg:text-2xl">
            Our Key Services:
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 md:mb-12">
          {[
            "Powerline Monitoring",
            "Forest & Wildlife Survey",
            "Bridge & Road Inspection",
            "Solar & Pipeline Inspection",
            "Disaster Management",
            "Railway & Industrial Inspection",
            "Mine Inspection",
            "Agricultural Survey",
            "Smart City Mapping",
          ].map((v, i) => (
            <div
              className="p-4 flex items-center gap-4 bg-white text-base md:text-lg rounded-lg"
              key={i}
            >
              <CheckIcon className="text-secondary" />
              <span>{v}</span>
            </div>
          ))}
        </div>
        <div className="flex justify-center mb-6">
          <div className="bg-white/50 font-semibold inline-block px-3 py-1 rounded-lg text-base lg:text-2xl">
            Why Choose EVERSE?
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 md:mb-12">
          {[
            "Advanced Drone Technology",
            "Safety-Focused Operations",
            "High-Quality Data Output",
            "Fast Turnaround Time",
            "Multi-Sector Expertise",
            "End-to-End Service Delivery",
          ].map((v, i) => (
            <div
              className="p-4 flex items-center gap-4 bg-white text-base md:text-lg rounded-lg"
              key={i}
            >
              <CheckIcon className="text-secondary" />
              <span>{v}</span>
            </div>
          ))}
        </div>
        <div className="flex justify-center mb-6">
          <div className="bg-white/50 font-semibold inline-block px-3 py-1 rounded-lg text-base lg:text-2xl">
            From planning to final data delivery we handle it all.
          </div>
        </div>
        <div className="flex justify-center">
          <Link
            href={routes.contact.url}
            className="bg-white px-6 py-3 rounded-full"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
